import UserAvatar from '../../ui-kit/components/atoms/UserAvatar'
import IconText from '../../ui-kit/components/molecules/IconText'
import {CELLPHONE_ICON} from '../../ui-kit/helpers/icons/cellphone'
import {PHONE_ICON} from '../../ui-kit/helpers/icons/phone'
import {PIN_ICON} from '../../ui-kit/helpers/icons/pin'
import {USER_ICON} from '../../ui-kit/helpers/icons/user'
import {TWITTER_ICON} from '../../ui-kit/helpers/icons/twitter'
import {FACEBOOK_ICON} from '../../ui-kit/helpers/icons/facebook'
import {LINKEDIN_ICON} from '../../ui-kit/helpers/icons/linkedin'
import SocialNetworkButton from '../atoms/SocialNetworkButton'
import {INSTAGRAM_ICON} from '../../ui-kit/helpers/icons/instagram'

const ProfileCard = () => {
  return (
    <article className="profile-card n-container">
      <header className="header">
        <UserAvatar />
      </header>
      <div className="content">
        <p className="title title-base">Evelyn Castrejón Jiménez</p>
        <div className="social-network-container">
          <SocialNetworkButton title="Facebook" url="#" icon={FACEBOOK_ICON} />
          <SocialNetworkButton title="Twitter" url="#" icon={TWITTER_ICON} />
          <SocialNetworkButton title="Linkedin" url="#" icon={LINKEDIN_ICON} />
          <SocialNetworkButton title="Instagram" url="#" icon={INSTAGRAM_ICON} />
        </div>
        <div className="info-list">
          <IconText className="small" text="311 132 5654" icon={CELLPHONE_ICON} />
          <IconText className="small" text="311 132 5654" icon={PHONE_ICON} />
          <IconText className="small" text="Sierra Nevada #8, Xalisco" icon={PIN_ICON} />
          <IconText className="small" text="Mujer" icon={USER_ICON} />
        </div>
      </div>
    </article>
  )
}

export default ProfileCard
